import React, { useState } from 'react';
import { PageHeader } from '../../components/UI';
import DashboardTab from './tabs/DashboardTab';
import LocationsTab from './tabs/LocationsTab';
import ItemsTab from './tabs/ItemsTab';
import StockTab from './tabs/StockTab';
import ReceiptTab from './tabs/ReceiptTab';
import DistributionTab from './tabs/DistributionTab';
import OpnameTab from './tabs/OpnameTab';
import MovementsTab from './tabs/MovementsTab';

const InventoryPage = () => {
  const [tab, setTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', component: DashboardTab },
    { id: 'locations', label: 'Lokasi', component: LocationsTab },
    { id: 'items', label: 'Item', component: ItemsTab },
    { id: 'stock', label: 'Stok', component: StockTab },
    { id: 'receipt', label: 'Penerimaan', component: ReceiptTab },
    { id: 'distribution', label: 'Distribusi', component: DistributionTab },
    { id: 'opname', label: 'Opname', component: OpnameTab },
    { id: 'movements', label: 'Pergerakan', component: MovementsTab },
  ];

  const CurrentTab = tabs.find(t => t.id === tab)?.component || DashboardTab;

  return (
    <div>
      <PageHeader title="Manajemen Inventaris" subtitle="Data dan informasi inventaris" />
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #E5E7EB', overflowX: 'auto' }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              padding: '12px 16px',
              borderBottom: tab === t.id ? '2px solid #2563EB' : 'none',
              color: tab === t.id ? '#2563EB' : '#6B7280',
              fontWeight: tab === t.id ? 600 : 500,
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <CurrentTab />
    </div>
  );
};

export default InventoryPage;
